  
import { createSlice } from "@reduxjs/toolkit";
import { checkLogin, getLoggedInUser } from "../../../../constants/localStorageFunctions"

const config = getLoggedInUser();
const loggedIn = checkLogin();
const initialState = {login:loggedIn,config:config}

const authSlice = createSlice({
name: "auth",
initialState,
reducers:{
setLoginState(state,action){
    state.login = action.payload;
},
setLoginUser(state,action){
    state.config = action.payload
},
setUsertoken(state,action){
    state.token = action.payload
}
}
});


export const { setLoginState, setLoginUser, setUsertoken } = authSlice.actions
export default authSlice.reducer